import React, { useState } from 'react';
import { Button } from '@components';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import Select from 'react-select';
import InputFile from '@app/components/input-file/InputFile';
import Editor from '@app/components/editor/Editor';
import { Post } from '@app/utils/httpProvider';
import { useMutation } from 'react-query';
import {
    messageError,
    messageToast,
    status200,
} from '../../utils/define';
import 'react-tabs/style/react-tabs.css';
import { KYSO_API } from '@app/utils/apiUrl';
import ReactSpinner from '@app/components/reactSpinner/ReactSpinner';
import DocumentInput from '@app/components/document-input/DocumentInput';

const schema = yup.object().shape({
    userName: yup
        .string()
        .required(messageError.emptyMessage),
    password: yup.string().required(messageError.emptyMessage),
});

const KySo = () => {
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);

    // const addFunc = useMutation((value) =>
    //     Post(KYSO_API.KYSO, null, value, false)
    // );

    const handleCreate = async (values) => {
        const model = { ...values };
        // model.parentId = values.parentId === 'null' ? '' : values.parentId;
        // model.parentId = '';
        // addFunc.mutate(model, {
        //     onSuccess: (res) => {
        //         if (res.status !== status200) {
        //             toast.error(messageToast.messageToastCreateError);
        //         } else {
        //             toast.success(messageToast.messageToastCreateSuccess);
        //             history.goBack();
        //         }
        //     },
        //     onError: (res) => {
        //         toast.error('Đã có lỗi xảy ra, vui lòng thử lại !');
        //     }
        // });
    };

    return (
        <Card>
            <Card.Header as="h5">Ký số</Card.Header>
            <Card.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={(values) => handleCreate(values)}
                    initialValues={{
                        userName: '',
                        password: '',
                        linkDocFile: '',
                    }}
                >
                    {({ handleSubmit, handleChange, values, errors, setFieldValue, touched, setFieldTouched }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    UserName *
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        placeholder="UserName"
                                        type="text"
                                        name="userName"
                                        value={values.userName}
                                        onChange={handleChange}
                                        isInvalid={!!errors.userName}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.userName}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Password *
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        placeholder="Password"
                                        type="text"
                                        name="password"
                                        value={values.password}
                                        onChange={handleChange}
                                        isInvalid={!!errors.password}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.password}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Họ tên người ký *
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        placeholder="Họ tên người ký"
                                        type="text"
                                        name="signatureName"
                                        value={values.signatureName}
                                        onChange={handleChange}
                                        isInvalid={!!errors.signatureName}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.signatureName}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Mid
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        placeholder="Mid"
                                        type="text"
                                        name="mid"
                                        value={values.mid}
                                        onChange={handleChange}
                                        isInvalid={!!errors.mid}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.mid}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-3 col-form-label">
                                    Export file word to pdf
                                </Form.Label>
                                <Col sm="9" className="icheck-primary">

                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-3 col-form-label">
                                    Upload files
                                </Form.Label>
                                <Col sm="9" className="icheck-primary">
                                    <DocumentInput
                                        value={values.linkDocFile}
                                        enableReinitialize={false}
                                        isInvalid={!!touched.linkDocFile && !!errors.linkDocFile}
                                        errorsValue={errors.linkDocFile}
                                        onChangeProp={(val) => {
                                            setFieldValue("linkDocFile", val);
                                            setFieldTouched("linkDocFile", true, false);
                                        }}
                                    />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Col md={{ span: 10, offset: 2 }}>
                                    <ButtonGroup className="mb-2">
                                        <Button
                                            type="submit"
                                            theme="primary"
                                            disabled={isLoading}
                                        >
                                            Thêm
                                        </Button>
                                        &nbsp;&nbsp;&nbsp;
                                        <Button
                                            onClick={() =>
                                                history.goBack()
                                            }
                                            theme="secondary"
                                        >
                                            Hủy
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Form.Group>
                        </Form>
                    )}
                </Formik>
                <ReactSpinner loadings={isLoading} />
            </Card.Body>
        </Card>
    );
};

export default KySo;
